import ReactDOM from 'react-dom/client';
import App from './App';
// import '../public/font/NotoSansTC-Regular-normal.js';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
